var PractitionerType = /* @__PURE__ */ ((PractitionerType2) => {
  PractitionerType2["DOCTOR"] = "DOCTOR";
  PractitionerType2["EXPERT"] = "EXPERT";
  PractitionerType2["ASSISTENT"] = "ASSISTENT";
  return PractitionerType2;
})(PractitionerType || {});
var Role = /* @__PURE__ */ ((Role2) => {
  Role2["NONE"] = "NONE";
  Role2["ASSISTANT"] = "ASSISTANT";
  Role2["ACCOUNTANT"] = "ACCOUNTANT";
  Role2["HYGIENIST"] = "HYGIENIST";
  Role2["DENTIST"] = "DENTIST";
  Role2["CLINIC_MANAGER"] = "CLINIC_MANAGER";
  Role2["RECEPTIONIST"] = "RECEPTIONIST";
  Role2["DENTAL_TECHNICIAN"] = "DENTAL_TECHNICIAN";
  Role2["DOCTOR"] = "DOCTOR";
  return Role2;
})(Role || {});
var Level = /* @__PURE__ */ ((Level2) => {
  Level2["CHIEF"] = "CHIEF";
  Level2["SENIOR"] = "SENIOR";
  Level2["JUNIOR"] = "JUNIOR";
  Level2["GRADUATE"] = "GRADUATE";
  return Level2;
})(Level || {});
var EmployeeStatus = /* @__PURE__ */ ((EmployeeStatus2) => {
  EmployeeStatus2["DISABLED"] = "DISABLED";
  EmployeeStatus2["INACTIVE"] = "INACTIVE";
  EmployeeStatus2["WILL_BE_ACTIVE"] = "WILL_BE_ACTIVE";
  EmployeeStatus2["ACTIVE"] = "ACTIVE";
  EmployeeStatus2["USED_TO_BE_ACTIVE"] = "USED_TO_BE_ACTIVE";
  EmployeeStatus2["UNKNOWN"] = "UNKNOWN";
  return EmployeeStatus2;
})(EmployeeStatus || {});
export {
  EmployeeStatus,
  Level,
  PractitionerType,
  Role
};
